import { DocumentNode, useMutation } from '@apollo/client';
import { FORM_ERROR } from 'final-form';
import { useSlideInContext, ApiValidationError, mapApiFieldValidationErrors, ApiUnknownError } from 'ui';
import { GET_SESSION_NOTES, GET_STUDENT_NOTES, ADD_STUDENT_NOTE_MUTATION, AddSessionNoteMutation, AddSessionNoteMutationVariables, AddStudentNoteMutation, AddStudentNoteMutationVariables, NoteOriginType, NoteTypeEnum, StudentDataType } from 'ft-shared-graphql';

import ReferralForm from './ReferralForm';
import { useParams } from 'react-router';
export const formatBody = (value: string) => {
    return value
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, (match) => match.toUpperCase()) // Capitalize first letter of each word
        .replace(/\B\w/g, (match) => match.toLowerCase()); // Lowercase the remaining characters
}
const formattedReferralTypes = {
    [NoteTypeEnum.Referral]: "Referral Made",
    [NoteTypeEnum.NoReferral]: "No referral needed",
    [NoteTypeEnum.Monitoring]: "Monitoring in house"
}
export type MakeAReferralProps = {
    studentId?: string,
    // sessionId?: string,
}
export default function MakeAReferral({ studentId }: MakeAReferralProps) {
    const [addStudentNoteMutation] = useMutation<AddStudentNoteMutation, AddStudentNoteMutationVariables>(ADD_STUDENT_NOTE_MUTATION);
    const { toggleDrawer } = useSlideInContext();
    const { sid } = useParams();
    const isSessionSpecific = (window.location.pathname.includes("notes") && !window.location.pathname.includes("children")) || (window.location.pathname.includes("session"))
    const noteOrigin = isSessionSpecific ? window.location.pathname.includes("notes") ? NoteOriginType.HistoryTable : NoteOriginType.ResultsTable : NoteOriginType.NotesTable
    const queriesToRefetch: { query: DocumentNode; variable?: any }[] = [
        studentId ? {
            query: GET_STUDENT_NOTES,
            variables: {
                studentId: studentId
            }
        } : null].filter(Boolean) as { query: DocumentNode; variables: any }[];

    const handleSubmitReferral = async (values: any) => {
        const _adjustedNote = formattedReferralTypes[values.noteType as keyof typeof formattedReferralTypes] || "";
        const response = await addStudentNoteMutation({
            variables: {
                studentId: studentId ?? sid,
                type: values.noteType,
                origin: noteOrigin,
                body: `${_adjustedNote} ${values.note ? ": " + values.note : ""}`
            },
            refetchQueries: queriesToRefetch
        })
        if (response.data?.addStudentNote.errors) {
            const validationError = response.data.addStudentNote.errors
                .find(e => e.__typename === "ValidationError") as ApiValidationError;
            if (validationError.errors) {
                const fieldErrors = validationError
                    ? mapApiFieldValidationErrors(validationError)
                    : null;

                return fieldErrors;
            }
            const unknownError = response.data.addStudentNote.errors
                .find(e => e.__typename === 'UnknownError') as ApiUnknownError;

            if (unknownError) {
                return { [FORM_ERROR]: unknownError.message }
            }
        }
        toggleDrawer();
    }
    return (
        <div>
            <ReferralForm
                onCancel={() => toggleDrawer()}
                onSubmit={async values => { handleSubmitReferral(values) }}
            />
        </div>
    )
}
